/*
 * Bad Waerme24 – Custom Theme JavaScript
 * Palo Alto Theme v9.0.1
 *
 * Features:
 *   1. Subtle Hover Glow on Product Cards
 *   2. Scroll Reveal Animations
 *   3. Animated Counters
 *   4. Sticky Add-to-Cart Bar
 *   5. Add-to-Cart Pulse Animation
 *   6. Header Scroll Effect
 *   7. Parallax Hero
 */

(function() {
  'use strict';

  /* =========================================================================
   * Utility: Feature Detection
   * ======================================================================= */

  var isTouchDevice = window.matchMedia('(pointer: coarse)').matches;
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* =========================================================================
   * 1. Subtle Hover Glow on Product Cards
   * ======================================================================= */

  function initCardHover() {
    if (isTouchDevice || prefersReducedMotion) return;

    var cards = document.querySelectorAll('.product-grid-item, .product-card');

    for (var i = 0; i < cards.length; i++) {
      (function(card) {
        if (card.hasAttribute('data-bw-hover-glow')) return;
        card.setAttribute('data-bw-hover-glow', 'true');

        card.style.transition = 'transform 0.3s ease, box-shadow 0.3s ease';

        card.addEventListener('mouseenter', function() {
          card.style.transform = 'translateY(-6px)';
          card.style.boxShadow = '0 12px 30px rgba(0,0,0,0.12), 0 0 0 1px rgba(201,169,110,0.15)';
        });

        card.addEventListener('mouseleave', function() {
          card.style.transform = '';
          card.style.boxShadow = '';
        });
      })(cards[i]);
    }
  }

  /* =========================================================================
   * 2. Scroll Reveal Animation
   * ======================================================================= */

  function initScrollReveal() {
    if (prefersReducedMotion) return;
    if (!('IntersectionObserver' in window)) return;

    // Only reveal explicitly marked elements — NOT all shopify-sections
    var elements = document.querySelectorAll('.bw-scroll-reveal');
    if (!elements.length) return;

    var observer = new IntersectionObserver(function(entries, obs) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          var el = entries[i].target;
          el.style.opacity = '1';
          el.style.transform = 'translateY(0)';
          obs.unobserve(el);
        }
      }
    }, {
      threshold: 0.1
    });

    for (var i = 0; i < elements.length; i++) {
      var el = elements[i];
      if (el.hasAttribute('data-bw-reveal-init')) continue;
      el.setAttribute('data-bw-reveal-init', 'true');

      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';

      observer.observe(el);
    }
  }

  /* =========================================================================
   * 3. Animated Counters
   * ======================================================================= */

  function initCounters() {
    if (!('IntersectionObserver' in window)) return;

    var counters = document.querySelectorAll('[data-bw-counter]');

    var observer = new IntersectionObserver(function(entries, obs) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          animateCounter(entries[i].target);
          obs.unobserve(entries[i].target);
        }
      }
    }, {
      threshold: 0.5
    });

    for (var i = 0; i < counters.length; i++) {
      if (counters[i].hasAttribute('data-bw-counter-init')) continue;
      counters[i].setAttribute('data-bw-counter-init', 'true');
      observer.observe(counters[i]);
    }
  }

  function animateCounter(el) {
    var target = parseFloat(el.getAttribute('data-bw-counter')) || 0;
    var suffix = el.getAttribute('data-bw-suffix') || '';
    var prefix = el.getAttribute('data-bw-prefix') || '';
    var duration = 2000;
    var startTime = null;
    var isInteger = target === Math.floor(target);

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var elapsed = timestamp - startTime;
      var progress = Math.min(elapsed / duration, 1);

      // Ease-out cubic: 1 - (1 - t)^3
      var easedProgress = 1 - Math.pow(1 - progress, 3);

      var currentValue = easedProgress * target;

      if (isInteger) {
        currentValue = Math.round(currentValue);
      }

      var formatted = currentValue.toLocaleString('de-DE');
      el.textContent = prefix + formatted + suffix;

      if (progress < 1) {
        requestAnimationFrame(step);
      }
    }

    requestAnimationFrame(step);
  }

  /* =========================================================================
   * 4. Sticky Add-to-Cart Bar
   * ======================================================================= */

  function initStickyATC() {
    if (!('IntersectionObserver' in window)) return;

    var stickyBar = document.querySelector('.bw-sticky-atc');
    if (!stickyBar) return;

    var atcButton = document.querySelector('.product-form__submit, .btn--add-to-cart');
    if (!atcButton) return;

    // Do NOT unobserve — sticky bar needs continuous observation
    var observer = new IntersectionObserver(function(entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          stickyBar.classList.remove('is-visible');
        } else {
          stickyBar.classList.add('is-visible');
        }
      }
    }, {
      threshold: 0
    });

    observer.observe(atcButton);
  }

  /* =========================================================================
   * 5. Add-to-Cart Pulse Animation
   * ======================================================================= */

  function initATCPulse() {
    var buttons = document.querySelectorAll('.product-form__submit, .btn--add-to-cart');

    for (var i = 0; i < buttons.length; i++) {
      (function(btn) {
        if (btn.hasAttribute('data-bw-pulse-init')) return;
        btn.setAttribute('data-bw-pulse-init', 'true');

        btn.addEventListener('click', function() {
          btn.classList.add('is-added');
          setTimeout(function() {
            btn.classList.remove('is-added');
          }, 600);
        });
      })(buttons[i]);
    }
  }

  /* =========================================================================
   * 6. Header Scroll Effect
   * ======================================================================= */

  var headerScrollBound = false;

  function initHeaderScroll() {
    if (headerScrollBound) return;

    var header = document.querySelector('.site-header');
    if (!header) return;

    headerScrollBound = true;

    function onScroll() {
      if (window.scrollY > 50) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    }

    // Set initial state
    onScroll();

    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* =========================================================================
   * 7. Parallax Hero
   * ======================================================================= */

  var parallaxBound = false;

  function initParallax() {
    if (isTouchDevice || prefersReducedMotion) return;
    if (parallaxBound) return;

    var images = document.querySelectorAll('.hero__media img, .slideshow__image img, .hero__bg img');
    if (!images.length) return;

    parallaxBound = true;

    // Set initial scale on all parallax images
    for (var i = 0; i < images.length; i++) {
      images[i].style.willChange = 'transform';
    }

    function onScroll() {
      var scrollY = window.scrollY || window.pageYOffset;

      // Re-query in case sections were reloaded
      var imgs = document.querySelectorAll('.hero__media img, .slideshow__image img, .hero__bg img');

      for (var i = 0; i < imgs.length; i++) {
        var rect = imgs[i].getBoundingClientRect();

        // Only apply parallax to images in or near the viewport
        if (rect.bottom < -200 || rect.top > window.innerHeight + 200) continue;

        var translateY = scrollY * 0.3;
        imgs[i].style.transform = 'translateY(' + translateY + 'px) scale(1.1)';
      }
    }

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Image hover is handled by the Palo Alto theme's built-in hover-wipe */

  /* =========================================================================
   * 8. Collection Page — "Mehr lesen" Toggle for Intro Text
   * ======================================================================= */

  function initCollectionReadMore() {
    if (!document.body.classList.contains('template-collection')) return;

    // Find the first text-section (intro text) — skip if it's the last one (SEO footer)
    var textSections = document.querySelectorAll('.text-section');
    if (!textSections.length) return;

    var introSection = textSections[0];
    var contentEl = introSection.querySelector('.text__content');
    if (!contentEl) return;
    if (contentEl.hasAttribute('data-bw-readmore-init')) return;
    contentEl.setAttribute('data-bw-readmore-init', 'true');

    // Add the collapsible class
    contentEl.classList.add('bw-collapsible-intro');

    // Mark the last text-section as SEO footer (no collapsing)
    if (textSections.length > 1) {
      textSections[textSections.length - 1].classList.add('bw-seo-footer');
    }

    // Only add toggle if content is actually overflowing
    // Need to wait a frame for CSS to apply
    requestAnimationFrame(function() {
      if (contentEl.scrollHeight <= 140) {
        contentEl.classList.remove('bw-collapsible-intro');
        return;
      }

      var btn = document.createElement('button');
      btn.className = 'bw-read-more-btn';
      btn.textContent = 'Mehr lesen';
      btn.setAttribute('aria-expanded', 'false');

      btn.addEventListener('click', function() {
        var isExpanded = contentEl.classList.toggle('is-expanded');
        btn.textContent = isExpanded ? 'Weniger anzeigen' : 'Mehr lesen';
        btn.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      });

      contentEl.parentNode.insertBefore(btn, contentEl.nextSibling);
    });
  }

  /* =========================================================================
   * 9. Collection Page — German Filter Labels
   * ======================================================================= */

  function initFilterTranslation() {
    if (!document.body.classList.contains('template-collection')) return;

    var translations = {
      'Availability': 'Verfügbarkeit',
      'availability': 'Verfügbarkeit',
      'Price': 'Preis',
      'price': 'Preis',
      'Size': 'Größe',
      'size': 'Größe',
      'Color': 'Farbe',
      'color': 'Farbe',
      'In stock': 'Auf Lager',
      'Out of stock': 'Ausverkauft',
      'Sort by': 'Sortieren nach',
      'Featured': 'Empfohlen',
      'Best selling': 'Bestseller',
      'Alphabetically, A-Z': 'Alphabetisch, A-Z',
      'Alphabetically, Z-A': 'Alphabetisch, Z-A',
      'Price, low to high': 'Preis aufsteigend',
      'Price, high to low': 'Preis absteigend',
      'Date, old to new': 'Älteste zuerst',
      'Date, new to old': 'Neueste zuerst'
    };

    // Translate filter toggle buttons, labels, and option text
    var elements = document.querySelectorAll(
      '.collection__filter-title, .collection__filter-label, ' +
      '.collection__sort-label, .collection__sort-option, ' +
      '[data-collapsible-trigger] span, ' +
      '.filter-group__heading, .filter-group__label'
    );

    for (var i = 0; i < elements.length; i++) {
      var el = elements[i];
      var text = el.textContent.trim();
      if (translations[text]) {
        el.textContent = translations[text];
      }
    }

    // Also translate <option> elements in sort dropdowns
    var options = document.querySelectorAll('.collection select option, select[name="sort_by"] option');
    for (var j = 0; j < options.length; j++) {
      var optText = options[j].textContent.trim();
      if (translations[optText]) {
        options[j].textContent = translations[optText];
      }
    }
  }

  /* =========================================================================
   * Master Initialization
   * ======================================================================= */

  function initAll() {
    initCardHover();
    initScrollReveal();
    initCounters();
    initStickyATC();
    initATCPulse();
    initHeaderScroll();
    initParallax();
    initCollectionReadMore();
    initFilterTranslation();
  }

  /* =========================================================================
   * Bootstrap: Run on DOM Ready or Immediately
   * ======================================================================= */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* =========================================================================
   * Shopify Theme Editor Compatibility
   * ======================================================================= */

  document.addEventListener('shopify:section:load', function() {
    initAll();
  });

  document.addEventListener('shopify:section:reorder', function() {
    initAll();
  });

})();
